import { useEffect, useState } from 'react';

/**
 * Hook to detect if app is running in Capacitor (native mobile app)
 * Returns platform: 'ios' | 'android' | 'web' | undefined (while detecting)
 */
export function useCapacitorPlatform() {
  const [platform, setPlatform] = useState<'ios' | 'android' | 'web' | undefined>(undefined);

  useEffect(() => {
    const detectPlatform = async () => {
      try {
        // Check if Capacitor is available
        const { Capacitor } = await import('@capacitor/core');
        
        if (Capacitor.isNativePlatform()) {
          const platform = Capacitor.getPlatform();
          if (platform === 'ios') {
            setPlatform('ios');
          } else if (platform === 'android') {
            setPlatform('android');
          } else {
            setPlatform('web');
          }
        } else {
          setPlatform('web');
        }
      } catch (error) {
        // Capacitor not available, running in web browser
        setPlatform('web');
      }
    };

    detectPlatform();
  }, []);

  return platform;
}

/**
 * Hook to check if app is running in Capacitor (native mobile)
 */
export function useIsCapacitor() {
  const platform = useCapacitorPlatform();
  return platform === 'ios' || platform === 'android';
}

